import EventAlertBackground from './EventAlertBackground';

export default EventAlertBackground;
